import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { assest } from "../Assest/Assest";

// Inline CSS styles
const styles = {
  container: {
    padding: "20px",
    textAlign: "center",
  },
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    animation: "fadeIn 1s ease-in-out",
    gap: "20px",
  },
  img: {
    transition: "transform 0.3s ease-in-out",
  },
  profile: {
    width: "200px",
    height: "200px",
    borderRadius: "100px",
  },
  title: {
    fontSize: "40px",
    fontWeight: "bold",
    color: "#00246B",
    textAlign: "center",
  },
};

// Keyframe animation
const keyframes = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @media (max-width: 768px) {
    .title { font-size: 30px !important; }
    .profile { width: 150px !important; height: 150px !important; }
  }
`;

// Injecting styles into the document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerHTML = keyframes;
document.head.appendChild(styleSheet);

const Dentin = () => {
  return (
    <Container style={styles.container}>
      <Row className="justify-content-center align-items-center">
        <Col xs={12} md={4} className="text-center">
          <img
            style={{ ...styles.img, ...styles.profile }}
            src={assest.Dentin}
            alt="Dentin"
            onMouseOver={(e) => (e.target.style.transform = "scale(1.1)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          />
        </Col>
        <Col xs={12} md={8}>
          <p style={styles.title} className="title">
            Dentin Dental Care & Implant Center
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Dentin;
